import { Api } from './axios-config';

export interface IPayoutRequestView {
  id: number;
  employeeWalletId: number;
  amount: number;
  status: number;
  statusName: string;
  requestedAt: Date;
  paidAt?: Date;
  notes?: string;
}

export interface IEmployeeWalletView {
  id: number;
  businessEmployeeId: number;
  employeeName: string;
  balance: number;
  pendingCommissions: number;
  lastUpdated: Date;
  payoutRequests: IPayoutRequestView[];
}

export interface ICreatePayoutRequest {
  employeeWalletId: number;
  amount: number;
}

export interface IProcessPayoutRequest {
  payoutRequestId: number;
  approved: boolean;
  notes?: string;
}

export interface IDirectPayoutRequest {
  employeeWalletId: number;
  amount: number;
  description?: string;
}

const getByEmployeeId = async (employeeId: number): Promise<IEmployeeWalletView> => {
  try {
    const { data } = await Api.get<IEmployeeWalletView>(`/employeewallet/employee/${employeeId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusinessId = async (businessId: number): Promise<IEmployeeWalletView[]> => {
  try {
    const { data } = await Api.get<IEmployeeWalletView[]>(`/employeewallet/business/${businessId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const requestPayout = async (dto: ICreatePayoutRequest): Promise<number> => {
  try {
    const { data } = await Api.post<number>('/employeewallet/payout', dto);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const processPayout = async (dto: IProcessPayoutRequest): Promise<void> => {
  try {
    await Api.put('/employeewallet/payout/process', dto);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const directPayout = async (dto: IDirectPayoutRequest): Promise<number> => {
  try {
    const { data } = await Api.post<number>('/employeewallet/payout/direct', dto);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const employeeWalletService = {
  getByEmployeeId,
  getByBusinessId,
  requestPayout,
  processPayout,
  directPayout,
};
